import { SchemesEnum } from '@cryptoboyio/mercuryo-lab';
import { createAction } from '@reduxjs/toolkit';

import { LanguageType } from '@utils/i18n';

import type { GlobalTypes } from '@modules';
import api from '@modules/api';
import { createAsyncActions, createActions } from '@modules/helpers';

import type { GlobalStateType } from './state';

const actions = createActions('global', {
  setFingerPrintData: name => createAction<Record<string, string>>(name),

  setCaptcha: name => createAction<string>(name),

  setShowCaptcha: name => createAction<boolean>(name),

  resetCaptcha: name => createAction(name),

  setScheme: name => createAction<SchemesEnum>(name),

  setLang: name => createAction<LanguageType>(name),

  setZHModalType: name => createAction<GlobalStateType['zhModalType']>(name),

  closeZHModal: name => createAction<void>(name),

  runZHFlow: name =>
    createAction<{ buy_token?: string; card_id?: string; cvv?: string } | undefined>(name),

  clickMenuItem: name => createAction<void>(name),

  redirectTo: name => createAction<GlobalTypes.RedirectToType>(name),

  setProtect: name => createAction<keyof typeof CONST.nav | undefined>(name),

  clearRedirect: name => createAction<void>(name),

  appStarted: name => createAction<void>(name),
});

export const asyncActions = createAsyncActions('global', {
  getCountries: (_: void, thunkApi) => api.get<GlobalTypes.Country[]>(thunkApi, '/lib/countries'),

  getStates: (params: GlobalTypes.GetStatesParams | void, thunkApi) =>
    api.get<GlobalTypes.States>(thunkApi, '/lib/states', { params }),

  getDataByIp: (_: void, thunkApi) =>
    api.get<GlobalTypes.DataByIpResponse>(thunkApi, '/public/data-by-ip'),

  getCurrencies: (_: void, thunkApi) =>
    api.get<GlobalTypes.Currencies>(thunkApi, '/lib/currencies'),

  getIbanPurposes: (_: void, thunkApi) =>
    api.get<GlobalTypes.IbanPurposes>(thunkApi, '/lib/iban-purposes'),

  getIbanCountries: (_: void, thunkApi) =>
    api.get<GlobalTypes.Country[]>(thunkApi, '/lib/iban-available-countries'),

  getCalcStart: (_: void, thunkApi) =>
    api.get<GlobalTypes.CalcStartResponse>(thunkApi, '/wallet/calc-log/start'),

  checkUKUserByIp: (_: void, thunkApi) =>
    api.get<GlobalTypes.DataByIpResponse>(thunkApi, '/public/data-by-ip'),
});

export default { ...actions, ...asyncActions };
